import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/pcg-table-column.interface';
import { DailyCountMetricsVm, DailyCountMetricsVmFromFg } from '../../Dashboard/Models/DailyCountMetricsVm';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class DailyCountWidgetVm {
	current?: DailyCountMetricsVm;
	previous?: DailyCountMetricsVm;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'current': DailyCountMetricsVm.Form,
			'previous': DailyCountMetricsVm.Form
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): DailyCountWidgetVmFromFg {
		return new DailyCountWidgetVmFromFg(fg);
	}
}

export class DailyCountWidgetVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get current(): DailyCountMetricsVmFromFg {
		return new DailyCountMetricsVmFromFg(this.fg.get('current') as UntypedFormGroup);
	}
	set current(val) {
		(this.fg.get('current') as UntypedFormGroup).setValue(val);
	}

	get previous(): DailyCountMetricsVmFromFg {
		return new DailyCountMetricsVmFromFg(this.fg.get('previous') as UntypedFormGroup);
	}
	set previous(val) {
		(this.fg.get('previous') as UntypedFormGroup).setValue(val);
	}
}
